(function () {
    'use strict';

    angular
        .module('app.score-detail')
        .component('sc3ScoreDetailChartPanel', {
            templateUrl: 'app/score-detail/score-detail-chart-panel/score-detail-chart-panel.component.html',
            transclude: {
                'panel-title': 'panelTitle',
                'chart-caption': 'chartCaption',
                'chart-sub-caption': '?chartSubCaption',
                'info': '?info',
            },
            controller: ScoreDetailChartPanelComponent,
            bindings: { chart: '<data' }
        });

    ScoreDetailChartPanelComponent.$inject = ['$element', '$transclude'];
    function ScoreDetailChartPanelComponent($element, $transclude) {
        var ctrl = this;
        ctrl.isSlotFilled = $transclude.isSlotFilled.bind($transclude);
        $element.addClass('panel panel-default mat-elevation-z6');
    }
})();